import { useQuery } from '@tanstack/react-query';
import { TenantDTO, UserDTO } from 'probonio-shared-ui/api';
import { apis } from 'probonio-shared-ui/module/api';
import { AdminTenantAccessData, getAdminTenantAccessData } from 'probonio-shared-ui/module/me/permissionSelectors';

export function useAdminTenantAccessData(user: UserDTO | undefined, initialData?: AdminTenantAccessData) {
  return useQuery({
    queryKey: ['adminTenantAccessData', user?.id, user?.roles?.toString(), user?.employments?.toString(), user?.tenantRoles?.toString()],
    queryFn: () => getAdminTenantAccessData(user),
    enabled: !!user,
    initialData,
    staleTime: 5 * 60 * 1000,
  });
}

export function useTenantHierarchies(tenantIds: TenantDTO['id'][], enabled: boolean = true) {
  const sortedIds = [...tenantIds].sort();
  return useQuery({
    queryKey: ['tenantHierarchies', sortedIds],
    queryFn: () => apis.tenants.getTenantHierarchies({ tenantIds }).then(resp => resp.data.rootTenants),
    enabled: enabled && tenantIds.length > 0,
    staleTime: 5 * 60 * 1000,
  });
}

export function useTenantSearch(filter: string, enabled: boolean) {
  return useQuery({
    queryKey: ['tenants', { filter, page: 0, pageSize: 10 }, apis.tenants.listTenants.name],
    queryFn: () => apis.tenants.listTenants({ filter, page: 0, pageSize: 10 }).then(resp => resp.data),
    enabled: !!filter && enabled,
    staleTime: Infinity,
  });
}
